var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage53({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.875 15v1.3c0 .186.068.364.188.495s.284.205.455.205h7.714a.62.62 0 0 0 .455-.205.73.73 0 0 0 .188-.495V3.7a.73.73 0 0 0-.188-.495.62.62 0 0 0-.455-.205H6.518a.62.62 0 0 0-.455.205.73.73 0 0 0-.188.495V5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 13.125 11.75 10 8.625 6.875M11.75 10H3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage53);
export default __webpack_public_path__ + "static/media/image53.89dae6addfb70c22087e5943589b80a9.svg";
export { ForwardRef as ReactComponent };